import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// ── Tickets ─────────────────────────────────────────────
export const ticketList = (params = '') => Http.get(`/admin/support/tickets${serialize(params)}`)
export const ticketByUuid = uuid => Http.get(`/admin/support/tickets/${uuid}`)
export const ticketUpdate = (uuid, data) => Http.put(`/admin/support/tickets/${uuid}`, data)
export const ticketAssign = (uuid, data) => Http.post(`/admin/support/tickets/${uuid}/assign`, data)
export const ticketClose = uuid => Http.post(`/admin/support/tickets/${uuid}/close`)
export const ticketReopen = uuid => Http.post(`/admin/support/tickets/${uuid}/reopen`)

// ── Messages ────────────────────────────────────────────
export const ticketReply = (uuid, data) => Http.post(`/admin/support/tickets/${uuid}/messages`, data)

// ── Staff ───────────────────────────────────────────────
export const staffList = (params = '') => Http.get(`/admin/support/staff${serialize(params)}`)
